import { FurnitureAndPersonalEffectsCategorySchema, FurnitureProps_1, RadioSelect, TextArea } from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { FC } from "react";
import { useForm } from "react-hook-form";

interface IProps {
  formId: string;
  store: FurnitureProps_1;
  onSubmit: (values: FurnitureProps_1) => void;
}

const Step02: FC<IProps> = ({ formId, store, onSubmit }) => {
  const { handleSubmit, control, watch } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(FurnitureAndPersonalEffectsCategorySchema)
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <RadioSelect
        title="Which category do you fall into?"
        name="category"
        id="category"
        control={control}
        options={[
          {
            label:
              "We don’t live together. We’ve have already divided our furniture & personal effects. We each keep what is in our respective residence.",
            value: "category_1"
          },
          {
            label:
              "We still have some jointly owned furniture & personal effects which needs to be divided, or we don’t fall into category 1.",
            value: "category_2"
          }
        ]}
        type="card-list"
      />
      {watch("category") === "category_2" ? (
        <TextArea
          title="Where is the jointly held (or undivided) furniture/property located?"
          subTitle="Eg if you wish to include valuable of sentimental items like artwork, antiques, family heirloom, expensive jewellery."
          name="description"
          id="description"
          control={control}
          theme="dark"
        />
      ) : null}
    </form>
  );
};
export default Step02;
